export const profileTabLabels = {
    "about": "Home",
    "content": "Newsletter",
  };